<template>
    <div class="performanceWaybillMapMonitorTab" :style="
                    isShowPlayer
                        ? 'height: calc(40% - 50px)'
                        : 'height: 40%'
                ">
        <el-tabs v-model="activeName">
            <el-tab-pane label="操作日记记录" name="eventManage">
                <div class="event-dis" v-if="taskNo">运单号：{{ taskNo }}</div>
                <ul class="event-timeline" v-if="eventList.length > 0">
                    <li
                        class="timeline-item"
                        v-for="(item, index) in eventList"
                        :key="index"
                    >
                        <div class="timeline-item__info">
                            <span>{{ item.eventName }}</span>
                            <span>{{ item.eventTime }}</span>
                        </div>
                    </li>
                </ul>
            </el-tab-pane>
            <el-tab-pane label="零担平台运单状态" name="ldTrackStatus">
                <div class="event-header" v-if="taskNo">
                    <div class="event-dis" v-if="taskNo">运单号：{{ taskNo }}</div>
                    <el-button type="primary" v-if="isShowProfessional" @click="getLclNodeByTaskNo" :loading="getLclNodeLoading">补抓专线节点</el-button>
                    <el-button type="primary" v-if="isShowTrackType" @click="getLclPointByTask" :loading="getLclPointLoading">补拉北斗轨迹</el-button>
                </div>
                <el-table
                    :data="ldTrackList"
                    border
                    style="width: 100%"
                    :height="130"
                >
                    <el-table-column
                        label="TMS状态"
                        prop="tmsStatusName"
                        show-overflow-tooltip
                    ></el-table-column>
                    <el-table-column
                        label="更新时间"
                        prop="billDate"
                        show-overflow-tooltip
                    ></el-table-column>
                    <el-table-column
                        label="数据来源"
                        prop="dataSource"
                        show-overflow-tooltip
                    ></el-table-column>
                    <el-table-column
                        label="零担系统状态"
                        prop="ldStatus"
                        show-overflow-tooltip
                    ></el-table-column>
                    <el-table-column
                        label="备注字段"
                        prop="content"
                        show-overflow-tooltip
                    ></el-table-column>
                    <el-table-column
                        label="零担系统司机"
                        prop="chauffer"
                        show-overflow-tooltip
                    ></el-table-column>
                    <el-table-column
                        label="零担系统车号"
                        prop="vehicleno"
                        show-overflow-tooltip
                    ></el-table-column>
                    <el-table-column
                        label="零担系统司机联系方式"
                        prop="chauffermb"
                        show-overflow-tooltip
                    ></el-table-column>
                </el-table>
            </el-tab-pane>

            <el-tab-pane label="轨迹信息" name="statisticsList">
                <el-table
                    :data="statisticsList"
                    border
                    style="width: 98%"
                    :height="180"
                >
                    <el-table-column label="轨迹来源" prop="trackingTypeName" show-overflow-tooltip></el-table-column>
                    <el-table-column label="最早打点时间" prop="earliestPointTime" show-overflow-tooltip></el-table-column>
                    <el-table-column label="最后打点时间" prop="latestPointTime" show-overflow-tooltip></el-table-column>
                    <el-table-column label="点数" prop="points" show-overflow-tooltip></el-table-column>
                    <el-table-column label="在线时长(min)" prop="onlineTime" show-overflow-tooltip></el-table-column>
                    <el-table-column label="应在线时长(min)" prop="shouldOnlineTime" show-overflow-tooltip></el-table-column>
                    <el-table-column label="在线率" prop="onlineRate" show-overflow-tooltip></el-table-column>
                </el-table>
            </el-tab-pane>
        </el-tabs>
    </div>
</template>
<script>
import { getLclNodeByTaskNo, getLclPointByTask } from '../../../../api/performanceWaybillMapMonitor.js';

export default {
    name: 'performanceWaybillMapMonitorTab',
    props: {
        taskNo: {
            type: String,
            default: ''
        },
        eventList: {
            type: Array,
            default () { return []; }
        },
        positionList: {
            type: Array,
            default () { return []; }
        },
        ldTrackList: {
            type: Array,
            default () { return []; }
        },
        statisticsList: {
            type: Array,
            default () { return []; }
        },
        taskNoData: {
            type: Object,
            default () { return {}; }
        },
        isShowPlayer: {
            type: Boolean
        }
    },
    data () {
        return {
            activeName: 'eventManage',
            getLclNodeLoading: false, // 补抓专线节点加载动画
            getLclPointLoading: false // 补拉北斗轨迹加载动画
        };
    },
    computed: {
        // 补抓专线节点: 专业公司为零担干线、发运类型为零担、是否下发零担平台为是、且零担平台为蓝桥/车满满时，显示按钮
        isShowProfessional () {
            if (this.taskNo && +this.taskNoData.professionalCompany === 3 && +this.taskNoData.shippingType === 0 &&
                this.taskNoData.isIssue === 'Y' && ['LQ', 'CMM'].includes(this.taskNoData.lclPlate)) {
                return true;
            };
            return false;
        },
        // 补拉北斗轨迹: 专业公司为零担干线、发运类型为零担、是否下发零担平台为是、零担平台为蓝桥/车满满、专线已发车，且有回传车牌时，显示按钮
        isShowTrackType () {
            // 专线是否已发车
            const isDispatch = this.ldTrackList.some(v => {
                return v.ldStatus === '发车' || v.ldStatus === '配载发车';
            });
            if (this.taskNo && +this.taskNoData.professionalCompany === 3 && +this.taskNoData.shippingType === 0 &&
                this.taskNoData.isIssue === 'Y' && ['LQ', 'CMM'].includes(this.taskNoData.lclPlate) && isDispatch && this.taskNoData.lclVehicleCard) {
                return true;
            };
            return false;
        }
    },
    methods: {
        // 补抓专线节点
        getLclNodeByTaskNo () {
            this.getLclNodeLoading = true;
            getLclNodeByTaskNo({ taskNo: this.taskNoData.taskNo }).then(res => {
                if (res && +res.code === 0) {
                    this.$emit('getLclNodeByTaskNo');
                }
            }).finally(() => {
                this.getLclNodeLoading = false;
            });
        },
        // 补拉北斗轨迹
        getLclPointByTask () {
            this.getLclPointLoading = true;
            getLclPointByTask({ taskNo: this.taskNoData.taskNo }).then(res => {
                if (res && +res.code === 0) {
                    this.$emit('getLclPointByTask');
                }
            }).finally(() => {
                this.getLclPointLoading = false;
            });
        }
    }
};
</script>
<style lang="less">
@import url('./waybillList.less');
</style>
